import {CrudModel} from '@ngx-ivengi/crud';

export class Drawing extends CrudModel {
  public name: string;
  public file: FileList;
  public fileId: string;
  public fileName: string;
  public fileSrc: string = '';

  public setName(name: string): Drawing {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setFile(files: FileList): Drawing {
    if(files instanceof FileList) {
      this.file = files;
    }
    return this;
  }

  public setFileId(fileId: string): Drawing {
    if(typeof fileId === 'string') {
      this.fileId = fileId;
    }
    return this;
  }

  public setFileName(fileName: string): Drawing {
    if(typeof fileName === 'string') {
      this.fileName = fileName;
    }
    return this;
  }

  public setFileSrc(fileSrc: string): Drawing {
    if(typeof fileSrc === 'string') {
      this.fileSrc = fileSrc;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setName(response.name);

    if(response.file) {
      this
        .setFileId(response.file.id)
        .setFileName(response.file.name);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing.model.ts